module.exports = __webpack_public_path__ + "media/images/ico-save-09f30754.svg";